interface Browser {
  name: string;
  version?: string | number;
}

export function getBrowser(): Browser {
  const { userAgent } = navigator;
  let currentMatches;
  let browserMatch =
    userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

  if (/trident/i.test(browserMatch[1])) {
    currentMatches = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
    return { name: "IE", version: currentMatches[1] || "" };
  }
  if (browserMatch[1] === "Chrome") {
    currentMatches = userAgent.match(/\bOPR\/(\d+)/);
    if (currentMatches !== null) {
      return { name: "Opera", version: currentMatches[1] };
    }
  }
  if (window.navigator.userAgent.indexOf("Edge") > -1) {
    currentMatches = userAgent.match(/Edge\/(\d+)/);
    if (currentMatches !== null) {
      return { name: "Edge", version: currentMatches[1] };
    }
  }
  if (window.navigator.userAgent.indexOf("Edg") > -1) {
    currentMatches = userAgent.match(/Edg\/(\d+)/);
    if (currentMatches !== null) {
      return { name: "Edge", version: currentMatches[1] };
    }
  }
  if (browserMatch[1] === "Safari") {
    currentMatches = userAgent.match(/Safari\/(\d+)/);
    if (currentMatches !== null) {
      return { name: "Safari", version: currentMatches[1] };
    }
  }
  browserMatch = browserMatch[2]
    ? [browserMatch[1], browserMatch[2]]
    : [navigator.appName, navigator.appVersion, "-?"];
  if (userAgent.match(/version\/(\d+)/i) !== null) {
    return { name: "MOBILE_VERSION" };
  }
  return {
    name: browserMatch[0],
    version: Number(browserMatch[1]),
  };
}
